module.exports = __webpack_public_path__ + "static/BeastPlatformer-a50f248c4e3582d358fd64cfce8649b8.png";